import React from "react";
import PublicLayout from "../components/PublicLayout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { useLang, useT } from "../lib/i18n";

const FAQS = {
  en: [
    ["How do I book a seat on daily services?", "Go to Daily Routes, pick a departure and enter passenger details. You can pay online or at pickup."],
    ["Can I cancel my booking?", "Yes — cancellation up to 24 hours before departure is refundable minus a small fee. Contact us via WhatsApp for assistance."],
    ["Do I need an account?", "No. Guest booking works — you'll get a Booking ID that you can use to view/manage your booking anytime."],
    ["Are drivers experienced?", "All our drivers are licensed, verified and have handled long trips across Maharashtra."],
    ["Do you offer pilgrim tours?", "Yes! Check the Upcoming Tours page — Ashtavinayak, Balaji, Vaishnodevi, Mahabaleshwar and more."],
  ],
  mr: [
    ["दैनिक सेवांसाठी जागा कशी बुक करावी?", "दैनिक मार्ग पानावर जा, प्रस्थान निवडा आणि प्रवाशांची माहिती भरा. आपण ऑनलाइन किंवा पिकअपच्या वेळी पैसे भरू शकता."],
    ["मी माझी बुकिंग रद्द करू शकतो का?", "होय — प्रस्थानाच्या २४ तासांपूर्वी रद्द केल्यास लहान शुल्क वजा करून परतावा मिळतो. मदतीसाठी व्हॉट्सअ‍ॅपवर संपर्क साधा."],
    ["खाते आवश्यक आहे का?", "नाही. अतिथी बुकिंग चालते — आपल्याला एक बुकिंग आयडी मिळेल जो कधीही बुकिंग पाहण्यासाठी वापरता येईल."],
    ["चालक अनुभवी आहेत का?", "आमचे सर्व चालक परवानाधारक, सत्यापित आणि महाराष्ट्रभर लांब पल्ल्याचे प्रवास हाताळणारे आहेत."],
    ["तुम्ही यात्रा सहली आयोजित करता का?", "होय! आगामी सहली पानावर पाहा — अष्टविनायक, बालाजी, वैष्णोदेवी, महाबळेश्वर आणि बरेच काही."],
  ],
};

export default function FAQ() {
  const { lang } = useLang();
  const t = useT();
  const list = FAQS[lang] || FAQS.en;
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-4 pt-10 pb-16">
        <div className="text-xs uppercase tracking-widest text-[#ea580c] font-semibold">{t("faq.eyebrow")}</div>
        <h1 className="text-4xl sm:text-5xl font-display font-black tracking-tight">{t("faq.title")}</h1>
        <Accordion type="single" collapsible className="mt-8">
          {list.map(([q, a], i) => (
            <AccordionItem key={`faq-${q.slice(0, 20)}`} value={`faq-${i}`} data-testid={`faq-${i}`}>
              <AccordionTrigger className="text-left font-display font-semibold">{q}</AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </PublicLayout>
  );
}
